<template>
    <div>
        <h4>
            {{
                selectedTemplate.name
                    ? `Review Template: ${selectedTemplate.name}`
                    : 'No Review Template'
            }}
        </h4>
        <b-modal
            v-model="viewModal"
            id="view-modal"
            :title="`View: ${selectedItem && selectedItem.checkoff_type.name}`"
            ok-only
            ok-title="Cancel"
            ok-variant="warning"
            @ok="viewModal = false"
        >
            <b-container fluid v-if="viewModal">
                <b-row>
                    <b-col class="font-weight-bold pt-0" cols="4"
                        >Comments:</b-col
                    >
                    <b-col>{{
                        selectedCheckoff.comments || 'No Comments'
                    }}</b-col>
                </b-row>
                <b-row>
                    <b-col class="font-weight-bold pt-0" cols="4"
                        >Submiited By:</b-col
                    >
                    <b-col>{{
                        (x => x.first_name + ' ' + x.last_name)(
                            selectedCheckoff.user
                        )
                    }}</b-col>
                </b-row>
                <b-row>
                    <b-col class="font-weight-bold pt-0" cols="4">Email:</b-col>
                    <b-col>{{ selectedCheckoff.user.email }}</b-col>
                </b-row>
            </b-container>
        </b-modal>
        <b-modal
            v-model="processModal"
            id="process-modal"
            :title="`Process: ${
                selectedItem && selectedItem.checkoff_type.name
            }`"
            @ok="confirmCheckOff"
        >
            <b-form>
                <!-- disable input fields when the user can only view and not update  -->
                <b-form-group
                    id="comments-group"
                    label="Comments"
                    label-for="input-comments"
                >
                    <b-form-textarea
                        type="text"
                        id="input-comments"
                        v-model="model.comments"
                        required
                        placeholder="Enter comments"
                        rows="3"
                        max-rows="6"
                    ></b-form-textarea>
                </b-form-group>
            </b-form>
            <template #modal-footer="{ ok, cancel }">
                <b-button size="sm" variant="success" @click="ok()">
                    Submit
                </b-button>

                <b-button size="sm" variant="warning" @click="cancel()">
                    Cancel
                </b-button>
            </template>
        </b-modal>
        <b-table
            striped
            hover
            :items="checkoffItems"
            :fields="fields"
            show-empty
        >
            <template #table-colgroup="scope">
                <col
                    v-for="field in scope.fields"
                    :key="field.key"
                    :style="{
                        width:
                            field.key === 'sequence_no'
                                ? '150px'
                                : field.key !== 'id'
                                ? '350px'
                                : null,
                    }"
                />
            </template>
            <template #cell(id)="{ item }">
                <b-button
                    v-if="!!item.order_checkoff"
                    size="sm"
                    variant="success"
                    @click="openViewModal(item)"
                    >View</b-button
                >

                <b-button
                    v-else
                    size="sm"
                    :disabled="!item.active"
                    variant="warning"
                    @click="openProcessModal(item)"
                    >Process</b-button
                >
            </template>
        </b-table>
    </div>
</template>
<script>
export default {
    name: 'OrderCheckoff',
    data: () => ({
        processModal: false,
        viewModal: false,
        fields: [
            { key: 'sequence_no' },
            {
                key: 'checkoff_type_id',
                label: 'Review Type',
                formatter: (value, key, item) => item.checkoff_type.name,
            },
            { key: 'id', label: 'Status' },
        ],
        model: {
            comments: null,
            checkoff_type_id: null,
        },
        selectedItem: null,
    }),

    computed: {
        user() {
            return this.$store.state.user
        },
        order() {
            const item = this.$store.state.orders.item
            console.log('computed---order', item)
            return item || {}
        },
        checkoffItems() {
            let items = this.selectedTemplate.types || []
            for (let i = 0; i < items.length; i++) {
                const item = items[i]
                let order_checkoff = this.order.checkoffs.find(
                    x => x.checkoff_type_id === item.checkoff_type_id
                )
                this.$set(item, 'order_checkoff', order_checkoff)
                this.$set(items, i, item)
            }
            items.sort((a, b) => a.sequence_no - b.sequence_no)
            let firstAvailableItem = null
            for (let i = 0; i < items.length; i++) {
                const item = items[i]
                this.$set(item, 'active', false)
                if (!firstAvailableItem && !item.order_checkoff) {
                    firstAvailableItem = item
                    this.$set(item, 'active', true)
                }

                if (
                    firstAvailableItem &&
                    !item.order_checkoff &&
                    firstAvailableItem.sequence_no == item.sequence_no
                ) {
                    this.$set(item, 'active', true)
                }

                if (!item.order_checkoff) {
                    const userHasRole = this.user.roles.some(
                        x => x.role_id === item.checkoff_type.role_id
                    )
                    if (item.active) this.$set(item, 'active', userHasRole)
                }

                this.$set(items, i, item)
            }

            return items
        },
        selectedTemplate() {
            const template =
                this.$store.state.checkoffTemplates.selectedTemplate
            console.log('checkoff template', template)
            return template || {}
        },
        selectedCheckoff() {
            const _selectedCheckoff =
                (this.selectedItem && this.selectedItem.order_checkoff) || {}
            console.log('selectedCheckoff', _selectedCheckoff)
            return _selectedCheckoff
        },
    },
    mounted() {
        console.log('checkoff user', this.user)
        console.log('checkoff order', this.order)
        const {
            type: { checkoff_template_id },
        } = this.order
        if (!checkoff_template_id) return
        this.$store.dispatch(
            'checkoffTemplates/fetchById',
            checkoff_template_id
        )
    },
    methods: {
        displayStatus(value) {
            return `<div>23456${value}</div>`
        },
        openViewModal(item) {
            this.selectedItem = item
            console.log('item', item)
            this.viewModal = true
        },
        openProcessModal(item) {
            this.selectedItem = item
            console.log('item', item)
            this.model.checkoff_type_id = item.checkoff_type_id
            this.model.comments = ''
            console.log('model before', this.model)
            this.processModal = true
        },
        async confirmCheckOff() {
            console.log('model after', this.model)
            const {
                order: { id },
                model: { comments, checkoff_type_id },
            } = this

            const data = { checkoff_type_id, comments }

            await this.$store.dispatch('orders/createCheckoff', { id, data })

            this.processModal = false
        },
    },
}
</script>